
import './styles/quasar.scss'
import lang from 'quasar/lang/fr.js'
import '@quasar/extras/roboto-font/roboto-font.css'
import iconSet from 'quasar/icon-set/svg-mdi-v6'
import Notify from 'quasar/src/plugins/Notify.js';

// To be used on app.use(Quasar, { ... })
export default {
  config: {
    notify: {
      position: "right",
    }
  },
  plugins: [
    Notify,
  ],
  lang: lang,
  iconSet: iconSet,
}
